

export default class InvoiceSettingsOperations {
  
  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }
  
  contains(name) {
    if (name) {
      //
    }
    return false;
  }
  
  list(params) {
    var event = new InvoiceSettingsOperations.List.Operation(params);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static List = {
    Names: {
      Operation: 'InvoiceSettingsListQueryOperation',
      Notification: 'InvoiceSettingsListQueryNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function(params) {
      var event = {
        handler: InvoiceSettingsOperations.List.Names.Operation,
        eventName: InvoiceSettingsOperations.List.Names.Operation,
      }
      
      event["Params"] = params.data ? params.data : params;

      return event;
    },
  }

}